import { useEffect, useRef } from "react"
import { useCreateReportHistoryMutation } from "@/hooks/api/useReportHistoryQuery"
import type { CreateReportHistoryPayload } from "@/types/reportHistory"

/**
 * 리포트 페이지에서 데이터 로드 완료 시 조회 기록을 생성하는 훅.
 * payload가 변경될 때마다 호출 (필터 변경 → View Report 클릭 시 URL 갱신 → payload 변경).
 * 동일 payload에 대한 중복 호출은 직전 값과 비교하여 방지.
 */
export function useRecordReportView(
  payload: CreateReportHistoryPayload | null,
  dataReady: boolean,
) {
  const { mutate: createHistory } = useCreateReportHistoryMutation()
  const prevPayloadRef = useRef<string | null>(null)

  useEffect(() => {
    if (!dataReady || !payload) return

    // 필수 날짜가 비어있으면 기록 스킵 — URL searchParams가 아직 안 채워진 상태에서
    // 빈 문자열로 히스토리가 저장되는 것을 방지 (과거 데이터 오염 원인)
    if (!payload.dateStart || !payload.dateFinish) return

    // 직전 호출과 동일한 payload면 스킵
    const serialized = JSON.stringify(payload)
    if (prevPayloadRef.current === serialized) return
    prevPayloadRef.current = serialized

    // silent fire — 실패해도 UX에 영향 없음
    createHistory(payload, {
      onError: () => {},
    })
  }, [dataReady, payload, createHistory])
}
